import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getFocusAcquisitionCalendarApi,
    postFocusAcquisitionDataApi,
    getFocusAcquisitionByDateApi,
    postQuakeFileDataApi,
    deleteFileDataApi,
    getFocusAcquisitionDictTreeApi,
    postQuakeSourceFileDataApi,
    postFocusAcquisitioSourceFileApi,
    postFocusSourceFileListApi,
    deleteFocusSourceFileListApi,
    getFocusSourceFileListApi,
    getFocusVPFileListApi
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
    fileName: '',
    quakeSourceVO: ''
}

/* 获取日历上的数据 */
export const getFocusAcquisitionCalendarAction = createAsyncThunk(
    'FocusAcquisitionSlice/getFocusAcquisitionCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getFocusAcquisitionCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典*/
export const getFocusAcquisitionDictDataAction = createAsyncThunk('FocusAcquisitionSlice/getFocusAcquisitionDictDataAction', async (dictType, thunkAPI) => {
    const nameDataDict = getFocusAcquisitionDictTreeApi(dictType[0])
    return Promise.all([nameDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 通过日期获取数据 id */
export const getFocusAcquisitionByDateAction = createAsyncThunk(
    'FocusAcquisitionSlice/getFocusAcquisitionByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const data = await getFocusAcquisitionByDateApi(listDataParams) // 通过日期查询 id
            return data?.data?.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 保存数据 */
export const postFocusAcquisitionDataAction = createAsyncThunk(
    'FocusAcquisitionSlice/postFocusAcquisitionDataAction',
    async ({ detailList, quakeSource, itemList }, { dispatch }) => {
        try {
            await postFocusAcquisitionDataApi({ detailList, quakeSource, itemList }) // 修改
            return { isTrue: true } // 已保存状态
        } catch (error) {
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 上传文件 step1  */
export const postFocusFileDataAction = createAsyncThunk(
    'FocusAcquisitionSlice/postFocusAcquisitionFileDataAction',
    async ({ params, file }, thunkAPI) => {
        try {
            const data = await postQuakeFileDataApi(params, file)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 上传source文件 step2  */
export const postFocusAcquisitionSourceFileDataAction = createAsyncThunk(
    'FocusAcquisitionSlice/postFocusAcquisitionSourceFileDataAction',
    async ({ file, projectId, additional }, thunkAPI) => {
        try {
            const data = await postQuakeSourceFileDataApi(file, projectId, additional)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 上传source文件 step2  */
export const postFocusAcquisitionSourceFileAction = createAsyncThunk(
    'FocusAcquisitionSlice/postFocusAcquisitionSourceFileAction',
    async ({ params }, thunkAPI) => {
        try {
            const data = await postFocusAcquisitioSourceFileApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 查询上传 解析后的 source文件 step2  */
export const getFocusAcquisitionSourceFileAction = createAsyncThunk(
    'FocusAcquisitionSlice/postFocusAcquisitionSourceFileAction',
    async ({ quakeSouceFileIdList }, thunkAPI) => {
        try {
            const data = await getFocusSourceFileListApi(quakeSouceFileIdList)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 查询上传 解析后的 vp文件 step3  */
export const getFocusAcquisitionVPFileAction = createAsyncThunk(
    'FocusAcquisitionSlice/getFocusAcquisitionVPFileAction',
    async ({ projectId, produceDate }, thunkAPI) => {
        try {
            const data = await getFocusVPFileListApi(projectId, produceDate)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 查询source文件列表  */
export const postFocusSourceFileListAction = createAsyncThunk(
    'FocusAcquisitionSlice/postFocusSourceFileListAction',
    async (fileListParams, thunkAPI) => {
        try {
            const data = await postFocusSourceFileListApi(fileListParams)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 删除source文件列表  */
export const postDeleteFocusSourceFileAction = createAsyncThunk(
    'FocusAcquisitionSlice/postDeleteFocusSourceFileAction',
    async ({ fileId }, thunkAPI) => {
        try {
            const data = await deleteFocusSourceFileListApi(fileId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 清空文件 */
export const delFocusFileDataAction = createAsyncThunk(
    'FocusAcquisitionSlice/delFocusAcquisitionFileDataAction',
    async (params, thunkAPI) => {
        try {
            const data = await deleteFileDataApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const FocusAcquisitionSlice = createSlice({
    name: 'FocusAcquisitionSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
            state.fileName = ''
            state.quakeSourceVO = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getFocusAcquisitionCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getFocusAcquisitionDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postFocusAcquisitionDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 通过日期，获取 id 回显 */
        [getFocusAcquisitionByDateAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
            state.id = action.payload?.quakeSourceVO?.id
            state.fileName = action.payload?.quakeSourceVO?.fileName
            state.quakeSourceVO = action.payload?.quakeSourceVO
        },
    },
})
